// Sprint 68 — NFL team registry: DK abbreviation → ESPN logo slug + primary/secondary colors.
export const NFL_TEAMS = {
  ARI: { name: "Cardinals", espn: "ari", primary: "#97233F", secondary: "#FFB612" },
  ATL: { name: "Falcons", espn: "atl", primary: "#A71930", secondary: "#000000" },
  BAL: { name: "Ravens", espn: "bal", primary: "#241773", secondary: "#9E7C0C" },
  BUF: { name: "Bills", espn: "buf", primary: "#00338D", secondary: "#C60C30" },
  CAR: { name: "Panthers", espn: "car", primary: "#0085CA", secondary: "#101820" },
  CHI: { name: "Bears", espn: "chi", primary: "#C83803", secondary: "#0B162A" },
  CIN: { name: "Bengals", espn: "cin", primary: "#FB4F14", secondary: "#000000" },
  CLE: { name: "Browns", espn: "cle", primary: "#FF3C00", secondary: "#311D00" },
  DAL: { name: "Cowboys", espn: "dal", primary: "#003594", secondary: "#869397" },
  DEN: { name: "Broncos", espn: "den", primary: "#FB4F14", secondary: "#002244" },
  DET: { name: "Lions", espn: "det", primary: "#0076B6", secondary: "#B0B7BC" },
  GB: { name: "Packers", espn: "gb", primary: "#203731", secondary: "#FFB612" },
  HOU: { name: "Texans", espn: "hou", primary: "#03202F", secondary: "#A71930" },
  IND: { name: "Colts", espn: "ind", primary: "#002C5F", secondary: "#A2AAAD" },
  JAX: { name: "Jaguars", espn: "jax", primary: "#006778", secondary: "#D7A22A" },
  KC: { name: "Chiefs", espn: "kc", primary: "#E31837", secondary: "#FFB81C" },
  LAC: { name: "Chargers", espn: "lac", primary: "#0080C6", secondary: "#FFC20E" },
  LAR: { name: "Rams", espn: "lar", primary: "#003594", secondary: "#FFA300" },
  LV: { name: "Raiders", espn: "lv", primary: "#A5ACAF", secondary: "#000000" },
  MIA: { name: "Dolphins", espn: "mia", primary: "#008E97", secondary: "#FC4C02" },
  MIN: { name: "Vikings", espn: "min", primary: "#4F2683", secondary: "#FFC62F" },
  NE: { name: "Patriots", espn: "ne", primary: "#002244", secondary: "#C60C30" },
  NO: { name: "Saints", espn: "no", primary: "#D3BC8D", secondary: "#101820" },
  NYG: { name: "Giants", espn: "nyg", primary: "#0B2265", secondary: "#A71930" },
  NYJ: { name: "Jets", espn: "nyj", primary: "#125740", secondary: "#000000" },
  PHI: { name: "Eagles", espn: "phi", primary: "#004C54", secondary: "#A5ACAF" },
  PIT: { name: "Steelers", espn: "pit", primary: "#FFB612", secondary: "#101820" },
  SF: { name: "49ers", espn: "sf", primary: "#AA0000", secondary: "#B3995D" },
  SEA: { name: "Seahawks", espn: "sea", primary: "#002244", secondary: "#69BE28" },
  TB: { name: "Buccaneers", espn: "tb", primary: "#D50A0A", secondary: "#FF7900" },
  TEN: { name: "Titans", espn: "ten", primary: "#0C2340", secondary: "#4B92DB" },
  WAS: { name: "Commanders", espn: "wsh", primary: "#5A1414", secondary: "#FFB612" },
};

const ALIASES = { WSH: "WAS", JAC: "JAX", LA: "LAR", SD: "LAC", OAK: "LV", STL: "LAR" };

export const teamKey = (abbr) => {
  const k = String(abbr || "").toUpperCase().trim();
  return NFL_TEAMS[k] ? k : (ALIASES[k] || k);
};
export const teamInfo = (abbr) => NFL_TEAMS[teamKey(abbr)] || null;
export const teamColor = (abbr, fallback = "#a1a1aa") => teamInfo(abbr)?.primary || fallback;
export const teamLogoUrl = (abbr) => {
  const t = teamInfo(abbr);
  return t ? `https://a.espncdn.com/i/teamlogos/nfl/500/${t.espn}.png` : null;
};
export const headshotUrl = (sleeperId) => (sleeperId ? `https://sleepercdn.com/content/nfl/players/thumb/${sleeperId}.jpg` : null);

// Dark team colors (NE navy, HOU deep steel…) vanish on our black UI — lift them.
export const teamTextColor = (abbr) => {
  const t = teamInfo(abbr);
  if (!t) return "#a1a1aa";
  const hex = t.primary.replace("#", "");
  const [r, g, b] = [0, 2, 4].map((i) => parseInt(hex.slice(i, i + 2), 16));
  const lum = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  return lum < 70 ? t.secondary : t.primary;
};
